export interface VhostSettings {
	defaultFields?: string;
	blockedFields?: string;
	slackUrl?: string;
	lightLogo?: string;
	darkLogo?: string;
	offensive?: object;
	autoDeleteContent?: number;
	enable_fake_detection?: number;
	fake_detection_threshold?: number;
	fake_detection_automod?: number;
	enable_aws_deep_analysis?: number;
	enable_selfhosted_ml?: number;
	selfhosted_ml_url?: string;
}

export interface VhostInfo {
	id: string;
	name: string;
	logo: string;
	domain: string;
	domainmatch: string;
	class: string;
	mediadetailurl: string;
	emaildomain: string;
	contactemail: string;
	defaultuid: string;
	moderated: string;
	assetbase: string;
	moderationemail: string;
	media_deniedemail: string;
	media_approvedemail: string;
	storageurl: string;
	storagedomain: string;
	comments_approvedemail: string;
	moderationcallback: string;
	mediacallback: string;
	sessionlifetime: string;
	created: string | null;
	streamserver: string | null;
	streamlocation: string | null;
	externalstorageid: string;
	uploaderId: string;
	billingPlan?: string;
	usehttps: string;
	createdby: string;
	retired?: boolean;
	settings: VhostSettings;
}


export const defaultVhostInfo: VhostInfo = {
	id: '',
	name: '',
	logo: '',
	domain: '',
	domainmatch: '',
	class: '',
	mediadetailurl: '',
	emaildomain: '',
	contactemail: '',
	defaultuid: '',
	moderated: '',
	assetbase: '',
	moderationemail: '',
	media_deniedemail: '',
	media_approvedemail: '',
	storageurl: '',
	storagedomain: '',
	comments_approvedemail: '',
	moderationcallback: '',
	mediacallback: '',
	sessionlifetime: '',
	created: null,
	streamserver: null,
	streamlocation: null,
	externalstorageid: '',
	uploaderId: '',
	usehttps: '',
	createdby: '',
	retired: false,
	settings:{}
};
